import React from 'react'
import { Link } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'

const baseClasses =
  'inline-flex items-center justify-center w-9 h-9 rounded-lg border border-transparent ' +
  'bg-hero-red hover:bg-hero-red-60 transition-colors flex-shrink-0 ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-hero-red focus-visible:ring-offset-2'

export interface IconLinkButtonProps {
  to: string
  label: string
  icon: LucideIcon
  className?: string
}

export default function IconLinkButton({ to, label, icon: Icon, className = '' }: IconLinkButtonProps) {
  return (
    <Link
      to={to}
      title={label}
      aria-label={label}
      className={[baseClasses, className].join(' ').trim()}
    >
      <Icon size={14} className="text-white" aria-hidden />
    </Link>
  )
}
